import useUserInfo from '@/hooks/useUserInfo';
import { COMMERCE_ROLE_NAMES, ROLES } from '@/components/security/AppRoles';
import { useGetBusinessUserMeQuery } from '@/pages/Business/pages/Users/services';

/**
 * Determina si el usuario es de tipo comercio y por lo tanto su lugar es
 * /business-commerces y no el back office.
 *
 * Dos caminos:
 *  - Rol de comercio (business:commerce-crud | business:commerce-read): es
 *    definitivo, no hace falta consultar scopes.
 *  - Legado: business:operator + scope de comercio. Así se identificaba a los
 *    comercios antes de que existieran los roles propios; se mantiene para los
 *    usuarios que todavía no fueron migrados.
 */
const useCommerceScopedOperator = () => {
  const { permissions } = useUserInfo();

  const hasCommerceRole = permissions.some((permission) =>
    COMMERCE_ROLE_NAMES.includes(permission)
  );
  const isOperator = permissions.includes(ROLES.BUSINESS.operator);

  const { data: businessUserMe, isLoading } = useGetBusinessUserMeQuery(
    undefined,
    { skip: hasCommerceRole || !isOperator }
  );

  const hasCommerceScope =
    (businessUserMe?.scopes?.commerce?.include?.length ?? 0) > 0;

  const isCommerceScopedOperator =
    hasCommerceRole || (isOperator && hasCommerceScope);

  return {
    isCommerceScopedOperator,
    isLoading: !hasCommerceRole && isOperator && isLoading,
  };
};

export default useCommerceScopedOperator;
